import { useMemo } from 'react';
import { makeAsyncCardComponent } from '../internal/makeAsyncCardComponent';
import { jsx as _jsx } from "react/jsx-runtime";
export function withCardTitleResolver(options) {
  const {
    titleComponentLoader,
    TitleComponent
  } = options;
  if (titleComponentLoader && TitleComponent) {
    throw new Error('You can provide either a titleComponentLoader or a TitleComponent, not both.');
  }
  return CardRenderer => {
    return function CardWithResolvedTitle(props) {
      const MaybeAsyncCardTitleComponent = useMemo(() => {
        if (props.hasActionsLoadingError) {
          return null;
        }
        if (TitleComponent) {
          return TitleComponent;
        }
        if (!titleComponentLoader) {
          return null;
        }
        return makeAsyncCardComponent({
          loader: titleComponentLoader,
          LoadingComponent: () => /*#__PURE__*/_jsx("span", {
            children: props.cardData.definition.cardTitle
          })
        });
      }, [props.cardData.definition.cardTitle, props.hasActionsLoadingError]);
      const cardTitle = MaybeAsyncCardTitleComponent ? /*#__PURE__*/_jsx(MaybeAsyncCardTitleComponent, Object.assign({}, props.cardProps)) : props.cardData.definition.cardTitle;
      return /*#__PURE__*/_jsx(CardRenderer, Object.assign({}, props, {
        cardTitle: cardTitle
      }));
    };
  };
}